import "./Header.css";
import { Link } from "react-router-dom";
import { LandingPage } from "../../Pages/LandingPage/LandingPage";
import { useLocation } from "react-router-dom";
import { CartPage } from "../../Pages/Cart/CartPage";
import { useCartContext } from "../../context/Cart.context";
import { WishlistPage } from "../../Pages/WIshlist/WishlistPage";
import { useWishlistContext } from "../../context/Wishlist.context";
import { useFilterReducerContext } from "../../context/FilterReducer.context";
import { useAuthContext } from "../../context/Auth.context";
import { DashboardPage } from "../../Pages/DashboardPage/DashboardPage";
import { useThemeContext } from "../../context/Theme.context";
import { useState } from "react";

export const Header = () => {
  const { theme, toggleLightDarkTheme } = useThemeContext();
  const { cartProducts } = useCartContext();
  const { wishlistProducts } = useWishlistContext();
  const { dispatch, searchTerm } = useFilterReducerContext();
  const currentPath = useLocation();
  const { signout, userState } = useAuthContext();
  const [term, setTerm] = useState("");

  const debounce = (callbackFn, delay) => {
    let timeout;

    return (query) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callbackFn(query);
      }, delay);
    };
  };

  const handleDebounce = debounce(
    (str) => dispatch({ type: "SEARCH_BAR", payload: str }),
    1000
  );

  return (
    <nav>
      <div className="navbar">
        <Link to="/" element={<LandingPage />}>
          <h1 className="name">
            <i className="fas fa-bolt"></i> Stormpoint
          </h1>
        </Link>
        {currentPath.pathname === "/products" && (
          <input
            className="header-input"
            placeholder="Search"
            value={term ?? searchTerm}
            type="text"
            onChange={(e) => {
              handleDebounce(e.target.value);
              setTerm(e.target.value);
            }}
          />
        )}
        <div className="margin-left-auto">
          <div className="icon-container">
            {Object.keys(userState).length !== 0 && (
              <p>Hello, {userState.firstName}</p>
            )}
            <div className="badge">
              <Link to="/dashboard" element={<DashboardPage />}>
                <i className="fa-solid fas fa-user"></i>
              </Link>
            </div>
            <div className="badge">
              <Link to="/wishlist" element={<WishlistPage />}>
                <i className="far fa-heart"></i>
              </Link>
              {wishlistProducts.length === 0 ? null : (
                <div className="number">{wishlistProducts.length}</div>
              )}
            </div>
            <div className="badge">
              <Link to="/cart" element={<CartPage />}>
                <i className="fas fa-shopping-cart"></i>
              </Link>
              {cartProducts.length === 0 ? null : (
                <div className="number">{cartProducts.length}</div>
              )}
            </div>
            <Link to="/" element={<LandingPage />}>
              {Object.keys(userState).length !== 0 && (
                <div onClick={() => signout()} className="badge">
                  <i className="fas fa-sign-out"></i>
                </div>
              )}
            </Link>
            <i
              onClick={toggleLightDarkTheme}
              className={`${
                theme === "light" ? "fas fa-moon" : "fas fa-sun"
              } icon`}
            ></i>
          </div>
        </div>
        {currentPath.pathname === "/products" && (
          <input
            onChange={(e) =>
              dispatch({ type: "SEARCH_BAR", payload: e.target.value })
            }
            className="mobile-input"
            type="text"
            placeholder="Search"
          />
        )}
      </div>
    </nav>
  );
};
